"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveSepaBankAccountRequestPayloadToJSON = exports.SaveSepaBankAccountRequestPayloadFromJSONTyped = exports.SaveSepaBankAccountRequestPayloadFromJSON = void 0;
var runtime_1 = require("../runtime");
function SaveSepaBankAccountRequestPayloadFromJSON(json) {
    return SaveSepaBankAccountRequestPayloadFromJSONTyped(json, false);
}
exports.SaveSepaBankAccountRequestPayloadFromJSON = SaveSepaBankAccountRequestPayloadFromJSON;
function SaveSepaBankAccountRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'iban': json['iban'],
        'bic': json['bic'],
        'holder': !(0, runtime_1.exists)(json, 'holder') ? undefined : json['holder'],
    };
}
exports.SaveSepaBankAccountRequestPayloadFromJSONTyped = SaveSepaBankAccountRequestPayloadFromJSONTyped;
function SaveSepaBankAccountRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'iban': value.iban,
        'bic': value.bic,
        'holder': value.holder,
    };
}
exports.SaveSepaBankAccountRequestPayloadToJSON = SaveSepaBankAccountRequestPayloadToJSON;
//# sourceMappingURL=SaveSepaBankAccountRequestPayload.js.map